import { FaixaCarteiraPessoaJuridicaListagemComponent } from './pesquisa/listagem/faixa-carteira-pessoa-juridica-listagem.component';
import { FaixaCarteiraPessoaJuricaRoutingModule } from './faixa-carteira-pessoa-juridica-routing.module';
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { SharedModule } from "src/app/shared/shared.module";
import { FaixaCarteiraPessoaJuridicaPesquisaComponent } from './pesquisa/faixa-carteira-pessoa-juridica-pesquisa.component';
import { FaixaCarteiraPessoaJuridicaCadastroComponent } from './cadastro/faixa-carteira-pessoa-juridica-cadastro.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { LabelParticipantesConglomeradoModule } from '../../label-participantes-conglomerado/label-participantes-conglomerado.module';

@NgModule({
  imports: [ SharedModule,
            BrowserModule,
            CommonModule,
            FaixaCarteiraPessoaJuricaRoutingModule,
            LabelParticipantesConglomeradoModule,
            NgSelectModule],
  exports: [],
  declarations: [ FaixaCarteiraPessoaJuridicaPesquisaComponent,
                  FaixaCarteiraPessoaJuridicaListagemComponent,
                  FaixaCarteiraPessoaJuridicaCadastroComponent  ],
  providers: [],
  schemas: []
})
export class FaixaCarteiraPessoaJuridicaModule { }
